var DEFAULT_WINDOW_SETTINGS = {
  name: 'popup',
  width: 550,
  height: 450
};

var _buildWindowSettings = function _buildWindowSettings(width, height) {
  return "toolbar=yes,width=".concat(width, ",height=").concat(height);
};

export var openUrl = function openUrl(url) {
  var name = DEFAULT_WINDOW_SETTINGS.name,
      width = DEFAULT_WINDOW_SETTINGS.width,
      height = DEFAULT_WINDOW_SETTINGS.height;
  window.open(url, name, _buildWindowSettings(width, height));
};